var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoWithBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92045 13V6.45455H8.92614V13H7.92045ZM8.43182 5.36364C8.2358 5.36364 8.06676 5.29688 7.92472 5.16335C7.78551 5.02983 7.71591 4.86932 7.71591 4.68182C7.71591 4.49432 7.78551 4.33381 7.92472 4.20028C8.06676 4.06676 8.2358 4 8.43182 4C8.62784 4 8.79545 4.06676 8.93466 4.20028C9.0767 4.33381 9.14773 4.49432 9.14773 4.68182C9.14773 4.86932 9.0767 5.02983 8.93466 5.16335C8.79545 5.29688 8.62784 5.36364 8.43182 5.36364Z",
    fill: "#787486"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWithBackground);
export default __webpack_public_path__ + "static/media/InfoWithBackground.9749dbad7f0dfdfa019bf33ae89ac355.svg";
export { ForwardRef as ReactComponent };